<mat-progress-bar *ngIf="loading" color="primary" mode="buffer"></mat-progress-bar>

<mtna-search-box
  class="condensed"
  [debounce]="debounceSearch"
  i18n-placeholderText
  placeholderText="Find a Variable"
  (search)="handleSearch($event)"
></mtna-search-box>

<mat-nav-list>
  <cdk-virtual-scroll-viewport itemSize="48">
    <a
      *cdkVirtualFor="let variable of $any(variables); trackBy: trackByFn"
      [class.active]="activeVariable?.uri === variable?.uri"
      [routerLink]="[baseUrl + (variable?.uri || variable?.id)]"
      mat-list-item
    >
      <p class="variable-name" mat-line>{{ variable?.name }}</p>
      <p *ngIf="!!variable.label" mat-line>{{ variable?.label }}</p>
    </a>
  </cdk-virtual-scroll-viewport>
</mat-nav-list>
